import 'babel-polyfill'
import promise from 'es6-promise';
import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import element from './element'
import instance from './untils/axios'
import './assets/style/global.scss'
import './assets/style/iconfont.css'
Vue.use(element)
Vue.prototype.$axios = instance
Vue.config.productionTip = false

import { CONSTS } from './untils/consts'
Vue.prototype.contextPath = CONSTS.contextPath

promise.polyfill()

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js